<template>
  <div class="input-adapter-input-value input-adapter">
    <template v-if="label">
      <span class="highlight-label">
        {{ label }}
      </span>
    </template>

    <vux-input
      v-model="localValue"
      v-bind="$attrs"
      :show-clear="false"
    />
  </div>
</template>

<script>
  import VuxInput from 'vux/src/components/x-input'

  export default {
    name: 'InputAdapterInputValue',

    inheritAttrs: false,

    props: {
      value: {},
      label: {},
      cbs: {}
    },

    data () {
      return {
        localValue: this.value
      }
    },

    created () {
      this.$watch('valueStr', text => {
        this.cbs && this.cbs.setResponseValue(text || '未设置')
      }, {
        immediate: true
      })

      this.$watch('localValue', (val) => {
        this.cbs && this.cbs.syncLocalInputValue(val)
      }, {
        immediate: true
      })
    },

    computed: {
      valueStr () {
        return this.localValue
      }
    },

    components: {
      VuxInput,
    }
  }
</script>

<style lang="scss">
  .input-adapter-input-value {
    border-bottom: 1px solid #eeeeee;
  }
</style>
